<template>
  <div class="swiper-slide">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    mounted() {
      this.$nextTick(() => {
      if (this.$root.lazyLoad) {
          this.$root.lazyLoad.update();
        }
      });
    },
  }
</script>
